<template>
  <div class="product-detail-header-action-component">
    <product-collect v-if="!hideCollect && collect && collect.show"
                     class="product-detail-header-action-item"
                     :target-type="targetType"
                     :target-id="targetId"
                     :status="collect.status"
    />
    <product-gift v-if="gift && gift.show"
                  class="product-detail-header-action-item"
                  :show="gift.show"
                  :target-id="gift.targetId"
                  :target-type="gift.targetType"
                  :origin-price="gift.price"
                  :target-title="targetTitle"
                  :modal-guide-info="modalGuideInfo"
    />
  </div>
</template>

<script>
  import ProductGift from '@/components/ProductGift';
  import ProductCollect from '@/components/ProductCollect';
  import validator from '@/utils/validator';

  export default {
    name: 'ProductDetailHeaderAction',
    components: {
      ProductGift,
      ProductCollect,
    },
    props: {
      targetType: {
        type: String,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetTitle: {
        type: String,
        required: true,
      },
      gift: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      collect: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      hideCollect: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @item-padding: @size-extra-medium/2;
  .product-detail-header-action {
    &-component {
      flex-shrink: 0;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      font-size: @font-size-small;
      color: @color-text-light;
    }

    &-item {
      &:last-child {
        margin-left: @size-small;
      }
    }
  }
</style>
